import { useState, useDebugValue } from 'react'

// Wrapper di useState che mostra una label nei dev tools
export default function useStateWithLabel(initialValue, name) {
  const [value, setValue] = useState(initialValue)
  useDebugValue(value, value => `${name}: ${value}`)
  return [value, setValue]
}